
const SquareStates = Object.freeze({NULL: null, FLWR: 'F', SEED: 'S'});
const AllDirections = Object.freeze(
    ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']);


export {
  SquareStates,
  AllDirections,
};
